// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metric-card-card-Ltc3s {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 12px;
  min-width: 200px;
  padding: 16px;
  transition: all 0.2s ease;
}

.metric-card-header-fG88t {
  display: flex;
  align-items: center;
  gap: 12px;
}

.metric-card-icon-gSU_4 {
  --size: 32px;
  font-size: 20px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-xl);
  flex-shrink: 0;
  cursor: default;
}

.metric-card-label-UWOAC {
  color: var(--color-neutral-800);
  font-size: 15px;
  font-weight: var(--font-weight-medium);
}

.metric-card-value-rVLye {
  color: var(--color-neutral-700);
  font-size: var(--text-xl);
  font-weight: var(--font-weight-bold);
  margin-left: 4px;
}

.metric-card-emerald-AdZSr { 
  background-color: var(--color-emerald-50);
  color: var(--color-emerald-600);
}

.metric-card-red-u_lyj { 
  background-color: var(--color-red-50);
  color: var(--color-red-600);
}

.metric-card-blue-GK6qd { 
  background-color: var(--color-blue-50);
  color: var(--color-blue-600);
}

.metric-card-loading-VBrKU {
  background-color: var(--color-neutral-50);
  animation: metric-card-pulse-_bLHX 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.metric-card-loading-VBrKU > * {
  visibility: hidden;
}

@keyframes metric-card-pulse-_bLHX {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/metric-card/metric-card.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,2EAAyD;AAC3D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".card {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 200px;\n  padding: 16px;\n  transition: all 0.2s ease;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.icon {\n  --size: 32px;\n  font-size: 20px;\n  padding: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-xl);\n  flex-shrink: 0;\n  cursor: default;\n}\n\n.label {\n  color: var(--color-neutral-800);\n  font-size: 15px;\n  font-weight: var(--font-weight-medium);\n}\n\n.value {\n  color: var(--color-neutral-700);\n  font-size: var(--text-xl);\n  font-weight: var(--font-weight-bold);\n  margin-left: 4px;\n}\n\n.emerald { \n  background-color: var(--color-emerald-50);\n  color: var(--color-emerald-600);\n}\n\n.red { \n  background-color: var(--color-red-50);\n  color: var(--color-red-600);\n}\n\n.blue { \n  background-color: var(--color-blue-50);\n  color: var(--color-blue-600);\n}\n\n.loading {\n  background-color: var(--color-neutral-50);\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.loading > * {\n  visibility: hidden;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `metric-card-card-Ltc3s`,
	"header": `metric-card-header-fG88t`,
	"icon": `metric-card-icon-gSU_4`,
	"label": `metric-card-label-UWOAC`,
	"value": `metric-card-value-rVLye`,
	"emerald": `metric-card-emerald-AdZSr`,
	"red": `metric-card-red-u_lyj`,
	"blue": `metric-card-blue-GK6qd`,
	"loading": `metric-card-loading-VBrKU`,
	"pulse": `metric-card-pulse-_bLHX`
};
export default ___CSS_LOADER_EXPORT___;
